module.exports = __webpack_public_path__ + "static/socialmediawhite-ff95ec8a3184d7c7bf4879d9dfed37d6.jpg";